module.exports = __webpack_public_path__ + "static/top-100-searches-315798f802d5976aca1d78b2ecbc4762.png";